module.exports = __webpack_public_path__ + "static/media/icon-truck-delivery-cancelled.74c5c74c.png";